import ErrorMonitoring from "../Components/ErrorMonitoring/ErrorMonitoring";

const ErrorMonitoringPage = () => {
  return <ErrorMonitoring />;
};

export default ErrorMonitoringPage;
